const spellingTimes = [
    [
        "",
        200
    ],
    [
        "“",
        200
    ],
    [
        "I",
        84
    ],
    [
        "hope",
        338
    ],
    [
        "that,",
        423
    ],
    [
        "in",
        369
    ],
    [
        "2030,",
        723
    ],
    [
        "the",
        553
    ],
    [
        "process",
        792
    ],
    [
        "of",
        569
    ],
    [
        "going",
        523
    ],
    [
        "to",
        569
    ],
    [
        "a",
        384
    ],
    [
        "film",
        638
    ],
    [
        "becomes",
        592
    ],
    [
        "even",
        338
    ],
    [
        "more",
        338
    ],
    [
        "communal,",
        661
    ],
    [
        "more",
        338
    ],
    [
        "of",
        169
    ],
    [
        "a",
        84
    ],
    [
        "hub,",
        338
    ],
    [
        "and",
        253
    ],
    [
        "more",
        338
    ],
    [
        "of",
        169
    ],
    [
        "a",
        84
    ],
    [
        "community—because",
        1438
    ],
    [
        "I",
        84
    ],
    [
        "think",
        423
    ],
    [
        "the",
        253
    ],
    [
        "more",
        338
    ],
    [
        "we",
        169
    ],
    [
        "become",
        507
    ],
    [
        "device-heavy,",
        1100
    ],
    [
        "the",
        253
    ],
    [
        "more",
        338
    ],
    [
        "disconnected",
        1015
    ],
    [
        "we",
        169
    ],
    [
        "become.",
        592
    ],
    [
        "And",
        253
    ],
    [
        "I",
        84
    ],
    [
        "think",
        423
    ],
    [
        "that",
        338
    ],
    [
        "storytelling",
        1015
    ],
    [
        "is",
        769
    ],
    [
        "about",
        623
    ],
    [
        "generating",
        600
    ],
    [
        "empathy.”",
        500
    ],
    [
        "",
        500
    ]
];


export default spellingTimes;